<template>
    <div class="colorPicker border-light darker radius-normal font-weight-600 fs-small">
        <div class="currentColor d-flex justify-content-between align-items-center pointer" @click="toggleSwatch">
            <span>{{selectedColorName}}</span>
            <span class="colorBall" :style="{'background-color': selectedColor.code, 'border-color': selectedColor.codeSecundary}"></span>
        </div>
        <div class="swatch w-100 d-flex bg-lightest radius-normal border-light justify-content-between" v-if="isOpen">
                <span
                v-for="color in colors"
                :style="{'background-color': color.code, 'border-color': color.codeSecundary}"
                class="colorBall pointer"
                @click="updateColor(color)">
            </span>
        </div>
    </div>
</template>

<script>
export default {
    data: function(){
        return {
            isOpen: false,
            selectedColor: {id:1, code:"#00a9f0", className:"color-1", name:'Blue Bright'}
        }
    },
    props: {
        selectedId:{
            type: Number,
            default: 1
        },
        colors: {
            type: Array,
            default: [
                {id:1, code:"#00a9f0", className:"color-1", name:'Blue Bright'},
                {id:2, code:"#858ac9", className:"color-2", name:'Purple'},
                {id:3, code:"#6ac951", className:"color-3", name:'Green'},
                {id:4, code:"#f8d46f", className:"color-4", name:'Yellow'},
                {id:5, code:"#febb84", className:"color-5", name:'Orange'},
                {id:6, code:"#f16c64", className:"color-6", name:'Red'}
            ]
        }
    },
    mounted: function() {
        this.setSelectedById(this.selectedId);
    },
    computed: {
        selectedColorName: function(){
            return (this.selectedColor.name !== undefined)? this.selectedColor.name : this.selectedColor.code;
        }
    },
    methods: {
        updateColor: function(color) {
            this.selectedColor = color;
            this.$emit('colorChanged', color);
            this.toggleSwatch();
        },
        toggleSwatch: function() {
            this.isOpen = !this.isOpen;
        },
        setSelectedById: function(idToSelect) {
            for (let singleColor of this.colors) {
                if(singleColor.id == idToSelect){
                    this.selectedColor = singleColor;
                }
            }

        }
    }
}
</script>

<style lang="scss" scoped>
    .colorPicker{
        position: relative;

        .colorBall{
            width: 24px;
            height: 24px;
            border-radius: 50%;
            margin: 3px;
            border-width: 3px;
            border-style: solid;
        }

        .currentColor{
            padding: 3px 12px;
        }

        .swatch{
            position: absolute;
            left: 0;
            top: 100%;
            margin-top: 5px;
            z-index: 10;
            padding: 12px;
            flex-wrap: wrap;
        }
    }

</style>



// WEBPACK FOOTER //
// ColorPicker.vue?5ec06f30